import { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import IdentityContext from '../../contexts/IdentityContext';
import { QR_DEMO_BASE_PATH, useRoutes } from '../../hooks/useRoutes';

export default function RequireAuth({ isDemo = false }: { isDemo?: boolean }) {
  const { buildAbsolutePath } = useRoutes();
  const { pathname, search } = useLocation();

  const urlSearchParams = new URLSearchParams({ returnUrl: [pathname, search].join('') });

  const {
    identity: { isAuthenticated },
  } = useContext(IdentityContext);

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`${buildAbsolutePath(
          ['LOGIN'],
          undefined,
          isDemo ? QR_DEMO_BASE_PATH : undefined,
        )}?${urlSearchParams.toString()}`}
        replace
      />
    );
  }

  return <Outlet />;
}
